<template>
  <div>
    <div
      v-if="offerApply"
      class="wrapper m-auto text-left candidate-wrapper"
    >
      <div class="d-flex justify-content-between">
        <GoBackButton />
      </div>
      <div class="row">
        <div class="col-12 col-lg-9">
          <div
            v-if="offerApply"
            class="bg-card personalData col"
          >
            <div
              v-if="$can('jobs_manage') || offerApply.status === 'Accepted' || offerApply.status === 'Rejected'"
              class="status text-right"
            >
              {{ $t('pages.one-candidate.status', { status: $t(`generic.${offerApply.status.toLowerCase().replace(/\s/g,'')}`, offerApply.status) }) }}
            </div>
            <div v-if="offerApply">
              <div class="candidate-hero" />
              <div class="candidate-hero-info">
                <img
                  v-if="offerApply"
                  class="company-logo cv-avatar mx-auto mx-md-0"
                  :src="basepath + 'uploads/avatars/no_avatar.jpg'"
                >
                <div class="d-flex justify-content-end mt-2">
                  <div>
                    <div
                      v-if="(offerApply.status === 'New' || offerApply.status === 'Seen') && $can('jobs_manage')"
                      class="d-flex"
                    >
                      <b-button
                        v-b-modal.modal-inprocess
                        variant="outline-success"
                        class="status-change-btn"
                      >
                        {{ $t('pages.one-candidate.toInProcess') }}
                      </b-button>
                      <b-button
                        v-b-modal.modal-reject
                        variant="outline-danger"
                        class="status-change-btn"
                      >
                        {{ $t('pages.one-candidate.reject') }}
                      </b-button>
                    </div>
                    <div
                      v-if="offerApply.status === 'In process' && $can('jobs_manage')"
                      class="d-flex"
                    >
                      <b-button
                        v-b-modal.modal-accept
                        variant="outline-success"
                        class="status-change-btn"
                      >
                        {{ $t('pages.one-candidate.accept') }}
                      </b-button>
                      <b-button
                        v-b-modal.modal-reject
                        variant="outline-danger"
                        class="status-change-btn"
                      >
                        {{ $t('pages.one-candidate.reject') }}
                      </b-button>
                    </div>
                    <div v-if="offerApply.status === 'Accepted'">
                      <b-button
                        variant="success"
                        class="status-change-btn"
                        disabled
                        style="background-color: #008800 !important"
                      >
                        {{ $t('pages.one-candidate.accepted') }}
                      </b-button>
                    </div>
                    <div v-if="offerApply.status === 'Rejected'">
                      <b-button
                        variant="danger"
                        class="status-change-btn"
                        disabled
                        style="background-color: #ff0000 !important"
                      >
                        {{ $t('pages.one-candidate.rejected') }}
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-sm-8 pl-5">
                  <h2>{{ offerApply.user.first_name }} {{ offerApply.user.last_name }}</h2>
                  <p
                    v-if="offerApply.user.city && offerApply.user.country && offerApply.user.zip"
                    class="m-0"
                  >
                    <font-awesome-icon
                      icon="map-marker"
                    />
                    {{ offerApply.user.city }} ({{ offerApply.user.country }}) {{ offerApply.user.zip }}
                  </p>
                  <p
                    v-if="!offerApply.user.email"
                    class="m-0"
                    style="font-size: 0.9rem"
                  >
                    <font-awesome-icon
                      icon="mail-bulk"
                    />
                    {{ $t('generic.hidden-contact-details', 'Contact details hidden') }}
                  </p>
                  <div v-else>
                    <p class="m-0">
                      <font-awesome-icon
                        icon="envelope"
                      />
                      {{ offerApply.user.email }}
                    </p>
                    <p class="m-0">
                      <font-awesome-icon
                        icon="phone"
                      />
                      {{ offerApply.user.phone }}
                    </p>
                  </div>
                  <div
                    v-if="offerApply && offerApply.external_candidate && offerApply.external_candidate.cv_document"
                    class="sm-text download-cv mb-3"
                    @click="showCV"
                  >
                    <font-awesome-icon
                      icon="download"
                      class="mr-1"
                    />
                    {{ $t('pages.one-candidate.view-cv') }}
                  </div>
                </div>
                <div class="col-12 col-sm-4">
                  <div
                    v-if="cvExperiences.length"
                  >
                    <div
                      v-for="exp in cvExperiences"
                      :key="exp.id"
                      class="mt-1"
                    >
                      <!-- TODO: replace the placeholder here -->
                      <img
                        class="float-left mr-2 mt-1"
                        src="https://placehold.it/32x32"
                        alt="Placeholder"
                      >
                      <div>
                        <div>{{ exp.company }}</div>
                        <div>{{ exp.startDate }} - {{ exp.endDate || $t('generic.present', 'Present') }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3 pl-lg-0">
          <Advertisement v-if="mainCardsSize >= 2" />
          <FindCourses v-if="mainCardsSize >= 4" />
          <Internships v-if="mainCardsSize >= 7" />
          <PartnerServices v-if="mainCardsSize == 3 || mainCardsSize >= 8" />
        </div>
      </div>

      <!-- MODALS -->
      <div v-if="$can('jobs_manage')">
        <!-- Accept Modal -->
        <b-modal
          id="modal-accept"
          centered
          header-bg-variant="warning"
          :title="$t('generic.warning', 'Warning')"
          :ok-title="$t('generic.accept', 'Accept')"
          :cancel-title="$t('generic.cancel', 'Cancel')"
          @ok="changeStatus(offerApply, 'Accepted')"
        >
          <!-- eslint-disable -->
          <p
              class="my-4"
              v-html="$t('pages.one-candidate.modal-accept')"
          />
          <!-- eslint-enable -->
        </b-modal>
        <!--  -->

        <!-- Reject Modal -->
        <b-modal
          id="modal-reject"
          centered
          header-bg-variant="warning"
          :title="$t('generic.warning', 'Warning')"
          :ok-title="$t('generic.accept', 'Accept')"
          :cancel-title="$t('generic.cancel', 'Cancel')"
          @ok="changeStatus(offerApply, 'Rejected')"
        >
          <!-- eslint-disable -->
          <p
              class="my-4"
              v-html="$t('pages.one-candidate.modal-reject')"
          />
          <!-- eslint-enable -->
        </b-modal>
        <!--  -->

        <!-- In process modal -->
        <b-modal
          id="modal-inprocess"
          centered
          header-bg-variant="warning"
          :title="$t('generic.warning', 'Warning')"
          :ok-title="$t('generic.accept', 'Accept')"
          :cancel-title="$t('generic.cancel', 'Cancel')"
          @ok="changeStatus(offerApply, 'In process')"
        >
          <!-- eslint-disable -->
          <p
              class="my-4"
              v-html="$t('pages.one-candidate.modal-inprocess')"
          />
          <!-- eslint-enable -->
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import GoBackButton from '@/components/jobs/shared/GoBackButton';

import Advertisement from '@/components/jobs/infoSidebar/Advertisement';
import PartnerServices from '@/components/jobs/infoSidebar/PartnerServices.vue';
import Internships from '@/components/jobs/infoSidebar/Internships.vue';
import FindCourses from '@/components/jobs/infoSidebar/FindCourses.vue';

export default {
  components: {
    GoBackButton,
    Advertisement,
    PartnerServices,
    Internships,
    FindCourses,
  },
  data() {
    return {
      offerApplyId: null,
      offerApply: null
    }
  },
  computed: {
    onlyOldCv() {
      if(this.offerApply.user.cv) {
        if(!this.offerApply.user.cv.document && this.offerApply.cv) {
          return false;
        }
      } else {
        return true;
      }
      return false;
    },

    cvExperiences() {
      return (
          (this.offerApply
              && this.offerApply.user
              && this.offerApply.user.cv
              && this.offerApply.user.cv.experience
          )
              ? JSON.parse(this.offerApply.user.cv.experience)
              : []
      );
    },
    mainCardsSize() {
      let count = 0;
      if(this.offerApply) {
        count += 2;
        if(this.offerApply.user.cv) {
          this.offerApply.user.cv.levels && (count += 2);
          this.offerApply.user.cv.educations && ( count += 1);
          this.offerApply.user.cv.languages && ( count += 1);
          this.offerApply.user.cv.skills && ( count += 1);
          this.offerApply.user.cv.text_cv && ( count += 1);
        }
      }  else {
        return 0;
      }
      return count;
    },
    basepath() {
      return process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PUBLIC_PATH;
    }
  },
  mounted() {
    if(this.$route.params.id) {
      this.offerApplyId = this.$route.params.id;
      this.axios.get('/offerApply/candidate/' + this.offerApplyId)
          .then( response => {
            this.offerApply = response.data;

            if (!this.offerApply.user && this.offerApply.external_candidate) {
              this.offerApply.user = this.offerApply.external_candidate;
              this.offerApply.isExternal = true;
            }

            if(this.$can('jobs_manage'))
              this.changeStatus(this.offerApply, this.offerApply.status);
          })
          .catch();
    } else if (this.$route.query.offer) {
      this.axios.get('/offerApply/intern/' + this.$route.query.offer)
          .then( response => {
            this.offerApply = response.data;
          })
          .catch();
    }
  },
  methods: {
    showCV() {
      if (this.offerApply && this.offerApply.external_candidate && this.offerApply.external_candidate.cv_document) {
        window.open(process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PUBLIC_PATH + 'uploads/external_candidates/' + this.offerApply.external_candidate.cv_document.filename);
      }
    },
    changeStatus(offerApply, currentStatus) {
      if (currentStatus === 'New') {
        currentStatus = 'Seen';
      } else if (currentStatus === 'Accepted') {
        currentStatus = 'Accepted';
      } else if (currentStatus === 'Rejected') {
        currentStatus = 'Rejected';
      } else if(currentStatus === 'In process') {
        currentStatus = 'In process';
      } else {
        return;
      }
      this.axios.put('/offerApply/changeStatus/' + offerApply.id, { status: currentStatus })
          .then( response => {
            this.offerApply.status = response.data.status;
          })
          .catch();
    },
  }
}
</script>


<style scoped lang="scss">
.cv-avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}

.facts {
  ul {
    margin: 0;

    li {
      font-size: 0.9rem !important;
      padding: 0;
    }
  }
}

.download-cv {
  cursor: pointer;
  transition: 0.2s ease;

  &:hover {
    font-weight: 600;
  }
}

.status {
  margin: 5px 0;
  font-size: 0.95rem;

  span {
    font-weight: 600;
  }
}

.status-change-btn {
  padding: 3px 10px;
  font-size: 0.9rem;
  font-weight: 600;
  margin: 0 3px;
}

.candidate-hero {
  background: url('../../../assets/company-hero.png');
  height: 150px;
}

.candidate-hero-info {
  background: #f2f2f2;
  display: flex;
  justify-content: space-between;
  padding: 0 2rem 2rem;
  flex-wrap: wrap;

  .middle {
    text-align: left;
    margin: 0 2rem;
    padding: 1.6rem 0;

    h1.title {
      font-size: 1.4rem !important;
      margin-bottom: 0 !important;
    }

    .category {
      font-size: 0.9rem;
    }
  }
}

.company-logo {
  width: 135px;
  height: 135px;
  border: 1px solid #efefef;
  box-shadow: 2px 3px 15px 10px rgba(0, 0, 0, 0.1), -1px 0 2px 0px rgba(0, 0, 0, 0.05);
  margin-top: -75px;

  &:hover {
    cursor: pointer;
  }
}

.offerBannerContainer {
  position: relative;

  &::before {
    content: '';
    background: rgba(0, 144, 144, 0.3);
    width: 100%;
    height: 50%;
    position: absolute;
  }

  img {
    z-index: 1;
  }
}
</style>
